import {
  createSelector,
  MemoizedSelector
} from '@ngrx/store';
import {
  selectRouterState
} from '../../selectors';
import {
  BreadcrumbsFunction,
  Breadcrumbs,
  AsyncBreadcrumbsFunction
} from '../../app-state';

export const getBreadcrumb: MemoizedSelector<any, Breadcrumbs | AsyncBreadcrumbsFunction | null> = createSelector(
  selectRouterState,
  state => {
    let breadcrumb = state.state.data.breadcrumb || null;
    if (breadcrumb) {
      if (typeof breadcrumb === 'function') {
        breadcrumb = breadcrumb(state.state);
      }
    }
    return breadcrumb;
  },
);
